import { getSepaMandates } from '@/api/sepa-mandates.api';
import type { IGetSepaMandate, SEPAMandate } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRef, computed, unref } from 'vue';

export const useSepaMandates = (query: MaybeRef<IGetSepaMandate>) => {
    const q = computed(() => unref(query));

    return useQuery(['sepa-mandates', q], () => getSepaMandates(q.value), {
        initialData: [] as SEPAMandate[],
    });
};
